import React from 'react'
import {UsersListWrapper} from './users-list'

const SupplierUsersPage: React.FC = () => {
  return <UsersListWrapper />
}

export {SupplierUsersPage}
